<template>
  <div class="gifts">
    <div class="gifts-center">
      <h1>Ønskelister</h1>
      <p>
        Som mange brudepar før oss har vi opprettet ønskelister hos <s title="Alle gaver vi ønsket oss hos Kitchn er allerede kjøpt!">Kitchn og</s> Tilbords, <s title="Dere har allerede kjøpt alle gavene her også, jo!">og vi er selvfølgelig vrange nok til å ha et par ønsker utenom.</s> <br> <br>
        Dersom du vil kjøpe en gave til oss, trenger du ikke pakke den inn - det blir nok ikke oss som pakker den opp uansett, 
        og vi trenger ikke bruke mer av regnskogen enn vi absolutt må, vel? <br> <br>
        <b style="color: pink;">VIKTIG:</b> Husk å huke av om dere kjøper gave fra en av listene - for <s>Kitch'n og</s> Tilbords skjer dette inne på lista deres, <s>imens for "div"-lista kan dere huke av her på nettsida</s>.

      </p>
      <wishlist v-for="(wishlist, wishlistIdx) in getNonEmptyWishlists" :key="wishlistIdx" :wishlist="wishlist" :wishlistIdx="wishlistIdx"></wishlist>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: { 

  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([ 'getWishlists', ]),
    getNonEmptyWishlists() {
      return this.getWishlists.filter(wl => {
        if(wl.gifts.every(gift => gift.bought >= gift.want)) return false
        else return true
      })
    }
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style lang="scss">
  .gifts {
    width: 100%;

    background-position: center;
    background-image: url("../assets/mountains.jpg");
    background-size: cover;
    background-attachment: fixed;

    text-align: center;

    

    & > .gifts-center {
      background-color: rgba(63, 63, 63, 0.76);
      width: 60vw;
      @media screen and (max-width: 900px){
        width: 100%;
      }
      margin: auto;
      min-height: 100vh;
      padding: 10px 0 50px;
      & > h1, & > p {
        padding: 20px 15px;
      }
    }
  }
</style>
